import { Box, Boxes } from "../types";

export function getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
}

export const boxesConfig: {
    [key in keyof typeof Box]: Boxes
} = {
    level1: {
        healthBoxes: 1,
        gunCartridges: 135,
        fireCartridges: 0,
        freezeCartridges: 0,
        bomb: 0,
    },
    level2: {
        healthBoxes: 1,
        gunCartridges: 75,
        fireCartridges: 0,
        freezeCartridges: 5,
        bomb: 0,
    },
    level3: {
        healthBoxes: 2,
        gunCartridges: 85,
        fireCartridges: 0,
        freezeCartridges: 10,
        bomb: 0,
    },
    level4: {
        healthBoxes: 2,
        gunCartridges: 95,
        fireCartridges: 0,
        freezeCartridges: 10,
        bomb: 0,
    },
    level5: {
        healthBoxes: 2,
        gunCartridges: 100,
        fireCartridges: 10,
        freezeCartridges: 10,
        bomb: 0,
    },
    level6: {
        healthBoxes: 3,
        gunCartridges: 565,
        fireCartridges: 10,
        freezeCartridges: 10,
        bomb: 0,
    },
    level7: {
        healthBoxes: 3,
        gunCartridges: 45,
        fireCartridges: 15,
        freezeCartridges: 40,
        bomb: 0,
    },
    level8: {
        healthBoxes: 0,
        gunCartridges: 5,
        fireCartridges: 55,
        freezeCartridges: 55,
        bomb: 0,
    },
    level9: {
        healthBoxes: 0,
        gunCartridges: 0,
        fireCartridges: 0,
        freezeCartridges: 0,
        bomb: 1,
    },
}